// Theme: sakura-night
// Auto-generated by scripts/materialize-theme-presets.ts
// Source of truth for theme configuration

import type { ThemePreset } from '@/lib/themes/types'

export const THEME_PRESET: ThemePreset = {
  id: 'sakura-night',
  name: 'SAKURA NIGHT',
  tagline: 'SAKURA NIGHT',
  description: 'Sakura noturna com contraste rosa-cereja e glow controlado.',
  category: 'fantasy-realms',
  tier: 'epic',
  basePrice: 2200,
  swatches: ['#0F0810', '#2A1525', '#E75480', '#FFE8F0'],
  baseStyle: {
    cardClasses: '',
    shapeVars: {
      '--border-w': '1px',
      '--radius': '12px',
      '--shadow-card': '0 12px 30px rgba(0, 0, 0, 0.24)',
      '--shadow-card-active': '0 0 22px color-mix(in srgb, var(--primary) 50%, transparent)'
    },
    shellClasses: 'font-sans theme-sakura-night'
  },
  colorVars: {
    '--accent': '#E75480',
    '--accent-foreground': '#0F0810',
    '--background': '#0F0810',
    '--border': '#7A3A5A',
    '--card': '#2A1525',
    '--card-border-active': 'rgba(231, 84, 128, 0.55)',
    '--card-completed': '#21131E',
    '--card-foreground': '#FFE8F0',
    '--card-glow': 'rgba(231, 84, 128, 0.10)',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#ef4444',
    '--destructive-foreground': '#0a0a0a',
    '--foreground': '#FFE8F0',
    '--hold-fill': '#E75480',
    '--input': '#7A3A5A',
    '--modal-bg': '#0F0810',
    '--modal-border': '#7A3A5A',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 12px 30px rgba(0, 0, 0, 0.24)',
    '--muted': '#7A3A5A',
    '--muted-foreground': '#FFE8F0',
    '--nav-active': '#E75480',
    '--nav-bg': '#2A1525',
    '--popover': '#2A1525',
    '--popover-foreground': '#FFE8F0',
    '--primary': '#E75480',
    '--primary-foreground': '#0F0810',
    '--ring': '#E75480',
    '--secondary': '#7A3A5A',
    '--secondary-foreground': '#FFE8F0',
    '--streak': '#E75480',
    '--success': '#22c55e',
    '--success-foreground': '#0F0810',
    '--xp': '#E75480',
    '--xp-bg': '#2A1525'
  },
  resolvedVars: {
    '--accent': '#E75480',
    '--accent-foreground': '#0F0810',
    '--accent-foreground-hsl': '293 33% 5%',
    '--accent-foreground-oklch': 'from #0F0810 l c h',
    '--accent-hsl': '342 75% 62%',
    '--accent-oklch': 'from #E75480 l c h',
    '--background': '#0F0810',
    '--background-hsl': '293 33% 5%',
    '--background-oklch': 'from #0F0810 l c h',
    '--border': '#7A3A5A',
    '--border-hsl': '330 36% 35%',
    '--border-oklch': 'from #7A3A5A l c h',
    '--border-w': '1px',
    '--card': '#2A1525',
    '--card-border-active': 'rgba(231, 84, 128, 0.55)',
    '--card-completed': '#21131E',
    '--card-completed-hsl': '313 27% 10%',
    '--card-completed-oklch': 'from #21131E l c h',
    '--card-foreground': '#FFE8F0',
    '--card-foreground-hsl': '339 100% 95%',
    '--card-foreground-oklch': 'from #FFE8F0 l c h',
    '--card-glow': 'rgba(231, 84, 128, 0.10)',
    '--card-hsl': '314 33% 12%',
    '--card-oklch': 'from #2A1525 l c h',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#ef4444',
    '--destructive-foreground': '#0a0a0a',
    '--destructive-foreground-hsl': '0 0% 4%',
    '--destructive-foreground-oklch': 'from #0a0a0a l c h',
    '--destructive-hsl': '0 84% 60%',
    '--destructive-oklch': 'from #ef4444 l c h',
    '--foreground': '#FFE8F0',
    '--foreground-hsl': '339 100% 95%',
    '--foreground-oklch': 'from #FFE8F0 l c h',
    '--hold-fill': '#E75480',
    '--hold-fill-hsl': '342 75% 62%',
    '--hold-fill-oklch': 'from #E75480 l c h',
    '--input': '#7A3A5A',
    '--input-hsl': '330 36% 35%',
    '--input-oklch': 'from #7A3A5A l c h',
    '--modal-bg': '#0F0810',
    '--modal-bg-hsl': '293 33% 5%',
    '--modal-bg-oklch': 'from #0F0810 l c h',
    '--modal-border': '#7A3A5A',
    '--modal-border-hsl': '330 36% 35%',
    '--modal-border-oklch': 'from #7A3A5A l c h',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 12px 30px rgba(0, 0, 0, 0.24)',
    '--muted': '#7A3A5A',
    '--muted-foreground': '#FFE8F0',
    '--muted-foreground-hsl': '339 100% 95%',
    '--muted-foreground-oklch': 'from #FFE8F0 l c h',
    '--muted-hsl': '330 36% 35%',
    '--muted-oklch': 'from #7A3A5A l c h',
    '--nav-active': '#E75480',
    '--nav-active-hsl': '342 75% 62%',
    '--nav-active-oklch': 'from #E75480 l c h',
    '--nav-bg': '#2A1525',
    '--nav-bg-hsl': '314 33% 12%',
    '--nav-bg-oklch': 'from #2A1525 l c h',
    '--popover': '#2A1525',
    '--popover-foreground': '#FFE8F0',
    '--popover-foreground-hsl': '339 100% 95%',
    '--popover-foreground-oklch': 'from #FFE8F0 l c h',
    '--popover-hsl': '314 33% 12%',
    '--popover-oklch': 'from #2A1525 l c h',
    '--primary': '#E75480',
    '--primary-foreground': '#0F0810',
    '--primary-foreground-hsl': '293 33% 5%',
    '--primary-foreground-oklch': 'from #0F0810 l c h',
    '--primary-hsl': '342 75% 62%',
    '--primary-oklch': 'from #E75480 l c h',
    '--radius': '12px',
    '--ring': '#E75480',
    '--ring-hsl': '342 75% 62%',
    '--ring-oklch': 'from #E75480 l c h',
    '--secondary': '#7A3A5A',
    '--secondary-foreground': '#FFE8F0',
    '--secondary-foreground-hsl': '339 100% 95%',
    '--secondary-foreground-oklch': 'from #FFE8F0 l c h',
    '--secondary-hsl': '330 36% 35%',
    '--secondary-oklch': 'from #7A3A5A l c h',
    '--shadow-card': '0 12px 30px rgba(0, 0, 0, 0.24)',
    '--shadow-card-active': '0 0 22px color-mix(in srgb, var(--primary) 50%, transparent)',
    '--streak': '#E75480',
    '--streak-hsl': '342 75% 62%',
    '--streak-oklch': 'from #E75480 l c h',
    '--success': '#22c55e',
    '--success-foreground': '#0F0810',
    '--success-foreground-hsl': '293 33% 5%',
    '--success-foreground-oklch': 'from #0F0810 l c h',
    '--success-hsl': '142 71% 45%',
    '--success-oklch': 'from #22c55e l c h',
    '--tint-primary-subtle': 'hsla(342 75% 62% / 0.15)',
    '--xp': '#E75480',
    '--xp-bg': '#2A1525',
    '--xp-bg-hsl': '314 33% 12%',
    '--xp-bg-oklch': 'from #2A1525 l c h',
    '--xp-hsl': '342 75% 62%',
    '--xp-oklch': 'from #E75480 l c h'
  }
}
